import { render } from "./users-list.vue?vue&type=template&id=b0a45660"
import script from "./users-list.vue?vue&type=script&lang=js"
export * from "./users-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__